// @flow

import DataLayerEvent from './DataLayerEvent';
import EventNames from '../../../../constants/DataLayer/EventNames';
import type Product from '../../../Product';
import { generateProduct } from '../../helpers';

export default class ViewProducts extends DataLayerEvent {
  /**
   * @inheritDoc
   */
  validate(): boolean {
    return Array.isArray(this.data) && this.data.length;
  }

  /**
   * @inheritDoc
   */
  dispatch(): void {
    super.dispatch();
    this.data = this.data.map((product: Product) => generateProduct(product));
    const lists: string[] = [...new Set(this.data.map((product: Product) => product.list))];

    lists.forEach((list: string) => {
      this.push({
        event: EventNames.VIEW_PRODUCTS,
        ecommerce: {
          items: this.data.filter((product: Product) => product.list === list)
        }
      });
    });
  }
}
